// extracted by mini-css-extract-plugin
export var table = "_w4-0";